import * as React from "react";
import { parseTagSanitizeAndWhitelist } from "../../../helpers/Utils";

export const RadioButtons = ({ keyRow, column, value, handleChange, disabled }) => {
	const handleRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
		handleChange(event.target.value);
	};

	return (
		<div className="input-group-cr">
			<div className="btn-group">
				{column?.options?.map((option) => (
					<label key={`${column.field}_${option?.name}`} className="checkset-inline">
						<input
							type="radio"
							readOnly
							name={`${column.field}_${keyRow}`}
							onChange={handleRadio}
							value={option.name}
							disabled={disabled}
							checked={(value && String(value) === String(option.name)) ?? false}
						/>
						<span>{parseTagSanitizeAndWhitelist(option.label)}</span>
					</label>
				))}
			</div>
		</div>
	);
};
